import React from "react";
import trans from "../../utils";
import BreadCrumb from "../Header/SecondHeader";
import { useSelector } from "react-redux";
import OfflineHeader from "../OfflineModules/OfflineHeader/OfflineHeader";
import ModeToggle from "../OfflineSetup/ModeToggle";
import { Helmet } from "react-helmet";
import ConstructionRequestHandle from "./ConstructionRequestsHandle/ConstructionRequestHandle";

export default function OfflineRequestsHandle() {
	const offlineMode = useSelector((state) => state.users.offlineMode);
	return (
		<>
			<Helmet>
				<title>Offline Requests</title>
				<meta name="description" content="IR" />
			</Helmet>
			{!offlineMode ? (
				<BreadCrumb title={trans("Offline Setup")} />
			) : (
				<OfflineHeader
					title={trans("Offline Setup")}
					subTitle={trans(
						"Configure modules for field use. Setup is required before activating Offline Mode",
					)}
					btn={<ModeToggle />}
				/>
			)}
			<ConstructionRequestHandle />
		</>
	);
}
